import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { noAuthGuard } from './core/guards/no-auth.guard';
import { MainLayout } from './layouts/main-layout/main-layout';


export const routes: Routes = [
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [noAuthGuard],
    loadChildren: () =>
      import('./features/auth/auth.routes').then((m) => m.authRoutes),
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/pages/dashboard/dashboard').then((m) => m.Dashboard),
        title: 'Gaulbridge | Dashboard'
      },
      {
        path: 'add-transactions',
        loadComponent: () =>
          import('./features/add-transactions/add-transactions').then((m) => m.AddTransactions),
        title: 'Gaulbridge | Add Transactions'
      },
      {
        path: 'clients',
        loadComponent: () =>
          import('./features/clients/clients').then((m) => m.Clients),
        title: 'Gaulbridge | Clients'
      },
      {
        path: 'clients/:id',
        loadComponent: () =>
          import('./features/clients/components/clients-detail/clients-detail').then((m) => m.ClientsDetail),
        title: 'Gaulbridge | Client Detail'
      },
      {
        path: 'roles-permissions',
        loadComponent: () =>
          import('./features/roles-permissions/roles-permissions').then((m) => m.RolesPermissions),
        title: 'Gaulbridge | Roles & Permissions'
      },
      {
        path: 'transactions',
        loadComponent: () => import('./features/transactions/transactions').then((m) => m.Transactions),
        title: 'Gaulbridge | Transactions'
      },
      {
        path: 'transactions/:id',
        loadComponent: () =>
          import('./features/transactions/components/transactions-detail/transactions-detail').then((m) => m.TransactionsDetail),
        title: 'Gaulbridge | Transaction Detail'
      },
      {
        path: 'rfi',
        loadComponent: () =>
          import('./features/rfi/rfi').then((m) => m.Rfi),
        title: 'Gaulbridge | RFI'
      },
      {
        path: 'investigations',
        loadComponent: () =>
          import('./features/investigations/investigations').then((m) => m.Investigations),
        title: 'Gaulbridge | Investigations'
      },
      {
        path: 'investigations/:id',
        loadComponent: () =>
          import('./features/investigations/investigation-detail').then((m) => m.InvestigationDetail),
        title: 'Gaulbridge | Investigation Detail'
      },
      {
        path: 'calculator',
        loadComponent: () =>
          import('./features/calculator/calculator').then((m) => m.Calculator),
        title: 'Gaulbridge | Calculator'
      },
      {
        path: 'security',
        loadComponent: () =>
          import('./features/sessions/sessions').then((m) => m.Sessions),
        title: 'Gaulbridge | Security'
      },
      {
        path: 'user-log',
        loadComponent: () =>
          import('./features/user-log/user-log').then((mod) => mod.UserLog),
        title: 'Gaulbridge | User Log'
      },
      {
        path: 'user-log-details/:id',
        loadComponent: () =>
          import('./features/user-log-details/user-log-details').then((mod) => mod.UserLogDetails),
        title: 'Gaulbridge | Activity Logs'
      },
      {
        path: 'user-actions',
        loadComponent: () =>
          import('./features/user-actions/user-actions').then((m) => m.UserActions),
        title: 'Gaulbridge | User Actions'
      },
      {
        path: 'business-info',
        loadComponent: () =>
          import('./features/business-info/business-info').then((m) => m.BusinessInfo),
        title: 'Gaulbridge | Business Info'
      },
      {
        path: 'virtual-account',
        loadComponent: () =>
          import('./features/clients/components/virtual-account/virtual-account').then((m) => m.VirtualAccount),
        title: 'Gaulbridge | Virtual Account'
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/pages/settings/settings').then((m) => m.Settings),
        title: 'Gaulbridge | Settings'
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./features/notifications/pages/notifications/notifications').then((m) => m.NotificationsPage),
        title: 'Gaulbridge | Notifications'
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
